<template>
  <el-dialog title="批量审核记录" :visible.sync="dialog.visible" width="1000px" append-to-body
    @close="handleClose">
    <div class="record-query">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-select v-model="query.auditStatus" placeholder="审核状态" clearable @change="handleSearch">
            <el-option v-for="item in auditStatusDict" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="table.bodys" v-loading="dialog.loading" stripe border max-height="520px"
      row-key="id">
      <el-table-column type="expand">
        <template v-slot="{ row }">
          <el-table :data="row.items || []" size="mini" border>
            <el-table-column label="资源位code" prop="code" min-width="140" align="center"></el-table-column>
            <el-table-column label="标题" prop="title" min-width="140" align="center"
              show-overflow-tooltip></el-table-column>
            <el-table-column label="操作类型" prop="operationName" width="120" align="center"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="审批实例号" prop="instanceCode" min-width="180" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column label="资源位数量" prop="itemCount" width="100" align="center"></el-table-column>
      <el-table-column label="审核状态" prop="auditStatusName" width="100" align="center">
        <template v-slot="{ row }">
          <el-tag :type="getAuditStatusTagType(row.auditStatus)" size="mini">
            {{ row.auditStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提交人" prop="submitter" width="110" align="center"></el-table-column>
      <el-table-column label="提交时间" prop="createTime" width="160" align="center"></el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template v-slot="{ row }">
          <el-button v-if="row.auditStatus === AUDIT_STATUS_PENDING" type="text" size="small"
            @click="handleCancel(row)">撤销</el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="record-pagination">
      <el-pagination background layout="total, sizes, prev, pager, next" :total="page.total"
        :current-page="page.current" :page-size="page.size" :page-sizes="[10, 20, 50]"
        @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import {
  getAppResourceItemBatchReviewPage,
  appResourceItemBatchReviewCancel
} from "@/api/desk/notice";

// 待审核状态值（仅该状态可撤销）
const AUDIT_STATUS_PENDING = 2;

export default {
  name: "resource-batch-review-record-dialog",
  data() {
    return {
      AUDIT_STATUS_PENDING,
      dialog: {
        visible: false,
        loading: false
      },
      // 当前资源组 id，由父组件在打开弹窗时传入，仅展示该资源组下的批次
      groupId: null,
      auditStatusDict: [
        { label: "草稿", value: 1 },
        { label: "待审核", value: 2 },
        { label: "审核通过", value: 3 },
        { label: "审核不通过", value: 4 }
      ],
      query: {
        auditStatus: ""
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      table: {
        bodys: []
      }
    };
  },
  methods: {
    show(groupId) {
      this.groupId = groupId;
      this.dialog.visible = true;
      this.page.current = 1;
      this.fetchList();
    },
    hide() {
      this.dialog.visible = false;
    },
    handleClose() {
      this.table.bodys = [];
      this.query.auditStatus = "";
      this.groupId = null;
    },
    fetchList() {
      this.dialog.loading = true;
      getAppResourceItemBatchReviewPage(this.page.current, this.page.size, {
        auditStatus: this.query.auditStatus,
        groupId: this.groupId
      }).then(res => {
        const data = res.data.data || {};
        this.table.bodys = data.records || [];
        this.page.total = data.total || 0;
        this.dialog.loading = false;
      }).catch(err => {
        console.error(this.$options.name, err);
        this.dialog.loading = false;
      });
    },
    handleSearch() {
      this.page.current = 1;
      this.fetchList();
    },
    handleCurrentChange(current) {
      this.page.current = current;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.page.size = size;
      this.page.current = 1;
      this.fetchList();
    },
    handleCancel(row) {
      this.$confirm("确定撤销该批次审核吗？撤销后批次内全部资源位将回退为草稿。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return appResourceItemBatchReviewCancel(row.id);
      }).then(() => {
        this.$message.success("撤销成功");
        this.fetchList();
        this.$emit("success");
      }).catch(err => {
        // 取消确认框或接口失败（失败已由拦截器 toast）
        if (err !== "cancel") {
          console.error(this.$options.name, err);
        }
      });
    },
    getAuditStatusTagType(auditStatus) {
      switch (auditStatus) {
        case 2:
          return "warning";
        case 3:
          return "success";
        case 4:
          return "danger";
        default:
          return "info";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.record-query {
  margin-bottom: 12px;
}

.record-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
